import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
const faqs = [{
  q: '¿Es para principiantes?',
  a: 'Sí, pero requiere compromiso. El sistema está diseñado para enseñarte desde los fundamentos (Lenguaje de Precio) hasta la ejecución precisa. No necesitas experiencia previa, pero sí disposición para estudiar y entrenar el ojo.'
}, {
  q: '¿Sirve si vengo de otra academia?',
  a: "Totalmente. Muchos alumnos llegan con 'vicios' o conceptos erróneos de otras academias. Protocolo Sniper te ayuda a limpiar el ruido, descartar lo que no sirve y enfocarte en una lectura objetiva del precio."
}, {
  q: '¿Incluye señales?',
  a: 'NO. El objetivo de Protocolo Sniper es que desarrolles criterio propio y no dependas de nadie. Enseño a pescar, no doy el pescado.'
}, {
  q: '¿La mentoría genera dependencia?',
  a: 'Al contrario. Está estructurada en 3 meses justamente para darte el acompañamiento necesario mientras integras el sistema, con el objetivo final de que operes de forma independiente y con total confianza.'
}, {
  q: '¿Qué pasa si ya compré un producto?',
  a: 'Si ya adquiriste el Pack y decides ingresar a la Mentoría, Tendrás un descuento, y accedes a precio especial de alumno.'
}, {
  q: '¿Es asesoramiento financiero?',
  a: 'No. Todo el contenido es estrictamente educativo. El trading conlleva un alto riesgo y los resultados dependen de la ejecución, disciplina y gestión de riesgo de cada individuo.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-24 md:py-32 bg-neutral-950" data-id="element-22">
      <div className="max-w-3xl mx-auto px-6 md:px-12" data-id="element-23">
        <FadeIn data-id="element-24">
          <div className="text-center mb-16" data-id="element-25">
            <span className="text-xs font-bold tracking-[0.2em] text-red-500 uppercase mb-4 block" data-id="element-26">
              Respuestas Claras
            </span>
            <h2 className="text-3xl md:text-5xl font-black text-white tracking-tight uppercase" data-id="element-27">
              Preguntas Frecuentes
            </h2>
          </div>
        </FadeIn>

        <div className="space-y-4" data-id="element-28">
          {faqs.map((faq, idx) => <FadeIn key={idx} delay={0.1 * idx} data-id="element-29">
              <div className="border border-neutral-800 bg-[#121212] rounded-sm overflow-hidden" data-id="element-30">
                <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-31">
                  <span className="font-bold text-white pr-8" data-id="element-32">{faq.q}</span>
                  <ChevronDown className={`w-5 h-5 text-neutral-500 transition-transform duration-300 shrink-0 ${openIndex === idx ? 'rotate-180 text-red-500' : ''}`} data-id="element-33" />
                </button>
                <AnimatePresence data-id="element-34">
                  {openIndex === idx && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-35">
                      <div className="px-6 pb-6 text-neutral-400 text-sm leading-relaxed border-t border-neutral-800/50 pt-4" data-id="element-36">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}